export default __webpack_public_path__ + "static/13-9-sitzer-elektro-3fff807edd91f6673956609802a80599.jpg";